module.exports = __webpack_public_path__ + "img/stakebodyatten_stopped.7dbd4dcd.svg";